import i18n from '../i18n';

const formatNumber = {
  methods: {
    formatNumber(amount) {
      if (!amount) return '';
      return new Intl.NumberFormat(`${i18n.locale}-CA`, { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    },
  },
};

export default formatNumber;



// WEBPACK FOOTER //
// ./src/mixins/formatNumber.js